<template>
  <b-overlay
      :show="overlay"
      rounded="sm"
  >
    <content-with-sidebar class="blog-wrapper">

      <!-- sidebar -->
      <div
          slot="sidebar"
          class="blog-sidebar py-2 py-lg-0"
      >
        <!-- input search -->
        <b-form-group class="blog-search">
          <b-input-group class="input-group-merge">
            <b-form-input
                id="search-input"
                v-model="debouncedSearch"
                @input=""
                placeholder="جستجو"
            />
            <b-input-group-append
                class="cursor-pointer"
                is-text
            >
              <feather-icon
                  icon="SearchIcon"
              />
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
        <!--/ input search -->
      </div>
      <!--/ sidebar -->

      <!-- blogs -->
      <b-row class="blog-list-wrapper">
        <b-col
            v-for="blog in blogList"
            :key="blog.blogId"
            md="6"
        >
          <b-card
              tag="article"
              no-body
          >
            <b-link :to="{ name: 'pages-blog-edit', params: { id: blog.blogId } }">
              <b-img
                  :src="baseUrl+blog.fileData"
                  class="card-img-top"
              />
            </b-link>
            <b-card-body>
              <b-card-title>
                <b-link
                    :to="{ name: 'pages-blog-edit', params: { id: blog.blogId } }"
                    class="blog-title-truncate text-body-heading"
                >
                  {{ blog.title }}
                </b-link>
              </b-card-title>
              <b-media no-body>
                <b-media-body>
                  <feather-icon
                      icon="CalendarIcon"
                      class="mr-50"
                  />
                  <small class="text-muted">
                    {{blog.createDate.slice(11,16)}}
                    -
                    {{createJalaliDate(blog.createDate.slice(0,10))}}
                  </small>
                  <span class="text-muted ml-75 mr-50">|</span>
                  <b-badge
                      pill
                      class="mr-75"
                      variant="primary"
                  >
                    {{ blog.categoryName }}
                  </b-badge>

                  <b-badge
                      v-if="blog.state === 1"
                      pill
                      class="ml-auto"
                      variant="success"
                  >
                    منتشر شده
                  </b-badge>
                  <b-badge
                      v-else-if="blog.state === 0"
                      pill
                      class="ml-auto"
                      variant="warning"
                  >
                    پیش‌نویس
                  </b-badge>
                </b-media-body>
              </b-media>
              <b-card-text class=" mt-1 item-description">
                {{ blog.summary }}
              </b-card-text>
              <hr>
              <div class="d-flex justify-content-between align-items-center">
              <span >
                <div class="d-flex align-items-center text-body">
                  <feather-icon
                      icon="MessageSquareIcon"
                      class="mr-50"
                  />
<!--                  <span class="font-weight-bold">{{ blog.commentsCount }} نظرات</span>-->
                  <span class="text-muted ml-75 mr-50">|</span>
                  <feather-icon
                      icon="EyeIcon"
                      class="mr-50"
                  />
                  <span class="font-weight-bold">{{ blog.viewCounts }} بازدید ها</span>
                </div>
              </span>
                <div>
                  <b-link
                      class="font-weight-bold text-danger mr-1"
                      v-b-modal.modal-delete
                      @click="showModal(blog.blogId)"
                  >
                    حذف
                  </b-link>
                  <b-link
                      :to="{ name: 'pages-edit-ghazal', params: { id: blog.blogId } }"
                      class="font-weight-bold"
                  >
                    ویرایش
                  </b-link>
                </div>
              </div>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col cols="12">
          <!-- pagination -->
          <div class="my-2">
            <QueriedPagination v-if="totalCount" v-model="currentPage" :total-counts="totalCount"
                               :per-page="8"></QueriedPagination>
          </div>
        </b-col>
      </b-row>
      <!--/ blogs -->
    </content-with-sidebar>
    <b-modal
        id="modal-delete"
        centered
        ok-title="حذف"
        cancelTitle="انصراف"
        @ok="deleteBlog(deleteItem)"
    >
      <span>حذف شود؟</span>
    </b-modal>
  </b-overlay>
</template>

<script>
import {
  BBadge,
  BCard,
  BCardBody,
  BCardText,
  BCardTitle,
  BCol,
  BFormGroup,
  BFormInput,
  BFormRadio,
  BImg,
  BInputGroup,
  BInputGroupAppend,
  BLink,
  BMedia,
  BMediaBody,
  BModal,
  BOverlay,
  BPagination,
  BRow,
} from 'bootstrap-vue'
import ContentWithSidebar from '@core/layouts/components/content-with-sidebar/ContentWithSidebar.vue'
import {BlogCategoryGetAllRequest, BlogDeleteRequest, BlogGetAllRequest} from "@/libs/Api/Blog";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import Helper from "@/libs/Helper";
import QueriedPagination from "@/views/components/QueriedPagination.vue";

export default {
  title:"لیست بلاگ ها - پنل ادمین ذهن آرایی",
  components: {
    QueriedPagination,
    BRow,
    BCol,
    BCard,
    BFormInput,
    BCardText,
    BCardBody,
    BCardTitle,
    BMedia,
    BMediaBody,
    BLink,
    BBadge,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BImg,
    BPagination,
    BFormRadio,
    BOverlay,
    BModal,
    ContentWithSidebar,
  },
  data() {
    return {
      overlay:false,
      baseUrl:Helper.baseUrl,
      searchQuery: '',
      blogList: null,
      blogSidebar: {},
      deleteItem:null,
      blogCategories:null,
      currentPage: 1,
      totalCount: null,
      categoryId:null,
      defaultGetProductData:{
        categoryId:0,
        searchByTitle:'',
        pageNumber:1,
        count:8,
        tagId:0,
      }
    }
  },
  async created() {
    if (this.$route.query.pageNumber) {
      this.defaultGetProductData.pageNumber = +this.$route.query.pageNumber
      this.currentPage = +this.$route.query.pageNumber
    }
    await this.getBlogs(this.defaultGetProductData.categoryId,this.defaultGetProductData.searchByTitle,this.defaultGetProductData.pageNumber);
    await this.getBlogCategories();
  },
  methods: {
    async getBlogs(categoryId,search,pageNumber){
      let _this = this;
      _this.overlay = true;
      let getBlogData={
        categoryId: 3,
        searchByTitle:search,
        pageNumber:pageNumber,
        count:8,
        tagId:0,
      }

      let blogGetAllRequest = new BlogGetAllRequest(_this);
      blogGetAllRequest.setParams(getBlogData)
      await blogGetAllRequest.fetch(function (content){
        _this.overlay = false;
        _this.blogList = content.blogs;
        _this.totalCount = content.blogsCount;
      } , function (content){
        _this.overlay = false;
      });
    },
    async getBlogCategories(){
      let _this = this;
      _this.overlay = true;

      let blogCategoryGetAllRequest = new BlogCategoryGetAllRequest(_this);
      await blogCategoryGetAllRequest.fetch(function (content){
        _this.overlay = false;
        _this.blogCategories = content
      } , function (content){
        _this.overlay = false;
      });
    },
    async deleteBlog(param){
      let _this = this;
      _this.overlay = true;

      let blogDeleteRequest = new BlogDeleteRequest(_this);
      blogDeleteRequest.setId(param);
      await blogDeleteRequest.fetch(function (content){
            _this.overlay = false;
            _this.$toast({
              component: ToastificationContent,
              position: 'bottom-center',
              props: {
                title: `عملیات موفق`,
                icon: 'CheckIcon',
                variant: 'success',
                text: `بلاگ حذف شد.`,
              },
            })
            _this.getBlogs(_this.defaultGetProductData.categoryId,_this.defaultGetProductData.searchByTitle,_this.defaultGetProductData.pageNumber)
          },
          function (error){
            _this.overlay = false;
          })
    },
    createJalaliDate(param){
      return new Date(param).toLocaleDateString("fa-IR",);
    },
    showModal(param){
      let _this = this;
      _this.deleteItem = param
    },
  },
  computed: {
    debouncedSearch: {
      get() {
        return this.searchQuery
      },
      set(val) {
        if (this.timeOut) {
          clearTimeout(this.timeOut)
        }
        this.timeOut = setTimeout(() => {
          this.searchQuery = val
        }, 600)
      }
    },
    getQuery() {
      return this.$route.query
    },
  },
  watch:{
    getQuery: function (nv, ov) {
      this.getBlogs(this.defaultGetProductData.categoryId,this.defaultGetProductData.searchByTitle,this.currentPage);
    },
    searchQuery:function (nv,ov){
      this.getBlogs(this.defaultGetProductData.categoryId,nv,this.defaultGetProductData.pageNumber);
    },
    categoryId:function (nv,ov){
      this.getBlogs(nv,this.defaultGetProductData.searchByTitle,this.defaultGetProductData.pageNumber);
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-blog.scss';
.item-description{
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
